import React from 'react';

import { Text } from '@atlaskit/primitives/compiled';
import type { Color } from '@atlaskit/status/element';
import { Status } from '@atlaskit/status/element';

export const StatusComponent = ({
	text,
	color,
	isBold,
}: {
	text: string;
	color: Color;
	isBold: boolean;
}) => (
	<Text as="span" testId="status-component">
		<Status text={text} color={color} isBold={isBold} />
	</Text>
);
